// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from './application';

import ClipboardController from './clipboard_controller';
application.register('clipboard', ClipboardController);

import DivisionFilterController from './division_filter_controller';
application.register('division-filter', DivisionFilterController);

import HelloController from './hello_controller';
application.register('hello', HelloController);

import LadderMatchScoreController from './ladder_match_score_controller';
application.register('ladder-match-score', LadderMatchScoreController);

import MatchScoreController from './match_score_controller';
application.register('match-score', MatchScoreController);
